import { Component, OnInit } from '@angular/core';

import { DataService } from '@data/data.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent implements OnInit {
  constructor(public dataService: DataService) {}

  ngOnInit() {}
}
